const SidebarManager = {
    elements: {
        sidebar: null,
        toggleBtn: null,
        overlay: null,
        closeBtn: null,
        factText: null,
        navHome: null,
        navAbout: null,
        navContact: null,
        navFaq: null
    },

    init: function () {
        console.log("SidebarManager: init() called.");
        this.cacheElements();
        this.bindEvents();
    },

    cacheElements: function () {
        this.elements.sidebar = document.getElementById('app-sidebar');
        this.elements.toggleBtn = document.getElementById('sidebar-toggle');
        this.elements.overlay = document.getElementById('sidebar-overlay');
        this.elements.closeBtn = document.getElementById('close-sidebar-btn');
        
        // Cache all nav links (both in top header and in sidebar if any)
        this.elements.navHome = document.querySelectorAll('#nav-home-btn');
        this.elements.navAbout = document.querySelectorAll('#nav-about-btn');
        this.elements.navContact = document.querySelectorAll('#nav-contact-btn');
        this.elements.navFaq = document.querySelectorAll('#nav-faq-btn');
    },

    bindEvents: function () {
        const self = this;

        // Function to bind clicks to NodeList
        const bindNav = (nodes, screenId) => {
            if (!nodes) return;
            nodes.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log("Nav Clicked -> Target Screen:", screenId);
                    
                    // Update active button state
                    document.querySelectorAll('.top-nav-link').forEach(link => link.classList.remove('active'));
                    btn.classList.add('active');

                    self.navigate(screenId);
                });
            });
        };

        bindNav(this.elements.navHome, 'category-screen');
        bindNav(this.elements.navAbout, 'about-screen');
        bindNav(this.elements.navContact, 'contact-screen');
        bindNav(this.elements.navFaq, 'faq-screen');

        if (this.elements.toggleBtn) this.elements.toggleBtn.addEventListener('click', () => this.toggle(true));
        if (this.elements.closeBtn) this.elements.closeBtn.addEventListener('click', () => this.toggle(false));
        if (this.elements.overlay) this.elements.overlay.addEventListener('click', () => this.toggle(false));
    },

    toggle: function (show) {
        const { sidebar, overlay } = this.elements;
        if (!sidebar || !overlay) return;

        if (show) {
            sidebar.classList.add('active');
            overlay.classList.remove('hidden');
            setTimeout(() => overlay.classList.add('active'), 10);
        } else {
            sidebar.classList.remove('active');
            overlay.classList.remove('active');
            setTimeout(() => overlay.classList.add('hidden'), 300);
        }
    },

    navigate: function (screenId) {
        this.toggle(false);
        const academicContainer = document.getElementById('academic-categories-container');
        if (academicContainer) {
            academicContainer.classList.add('hidden');
        }

        if (window.ui && window.ui.showScreen) {
            window.ui.showScreen(screenId);
        } else if (window.Router && window.Router.showScreen) {
            window.Router.showScreen(screenId);
        } else {
            console.warn("UI / Router showScreen not available");
        }
    }
};

window.SidebarManager = SidebarManager;
export default SidebarManager;
